import {
    InvestmentTransferDispatcher,
    TransferRequestDispatcher,
    MoveableSubAccountDispatcher,
    DestinationSubAccountDispatcher,
    MoveableSubAccountStore,
    DestinationSubAccountFromRequestDispatcher,
} from "../Stores/Variable";

import { ActionType } from "../../../../react-core/Flux/ActionType";
import { TransferSourceAccountsClient } from "../../../../Wrap/Api/Transfer/TransferAccounts/TransferSourceAccounts";
import { TransferDestinationAccountsClient } from "../../../../Wrap/Api/Transfer/TransferAccounts/TransferDestinationAccounts";
import { ProductInvestmentDetailsClient } from "../../../../Wrap/Api/Transfer/TransferInvestments/ProductInvestmentDetails";
import { ModelPortfolioInvestmentDetailsClient } from "../../../../Wrap/Api/Transfer/TransferInvestments/ModelPortfolioInvestmentDetails";
import { getQueryParameters } from "../../../Shared/Wizards/Entities/QueryParametersHelper";
import { IInvestmentTransfer } from "../Stores/InvestmentTransferStoreStatic";
import { AccountTransferInstruction } from "../../../../Wrap/Models/Models/Transfer/AccountTransferInstruction";
import { AccountTransferClient } from "../../../../Wrap/Api/Transfer/Instruction/AccountTransfer";
import { IApiError } from "../../../../react-core/Core/ApiError";
import { InterAccountTransferErrors } from "../../../../Wrap/Validation/Errors/Transfer/InterAccount/InterAccountTransferErrors";
import { TransferBeneficialOwnerClient } from "../../../../Wrap/Api/Transfer/TransferAccounts/TransferBeneficialOwner";
import { TransferDestinationAccountModel } from "../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { ServiceProposition } from "../../../../Wrap/Constants/Enums/ServiceProposition";

export class TransferWizardAction {
    public static getSourceAccount(hiercharyId: string): void {
        const client = new TransferSourceAccountsClient();
        const promise = client.get(hiercharyId);
        promise.onSuccess((data) => {
            MoveableSubAccountDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getModelPortofoilo(instructionCode: string, callback?) {
        const client = new ModelPortfolioInvestmentDetailsClient();
        const id = getQueryParameters()["id"];
        const promise = client.get(id, instructionCode);
        promise.onSuccess((data) => {
            if (callback) {
                callback(data);
            }
        });
    }

    public static getInvestment(subAccountId: string): void {
        const client = new ProductInvestmentDetailsClient();
        const promise = client.get(subAccountId);
        promise.onSuccess((data) => {
            InvestmentTransferDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data.investments.map((ele) => {
                    return {
                        detail: ele,
                        isMoveAll: false,
                        moveQuantity: null,
                        isToggle: false,
                        amendBookCost: null,
                        acquisitionDate: null,
                        CGT: false,
                    } as IInvestmentTransfer;
                }),
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getDestinationAccount(
        accountName: string,
        accountNum: string,
        forname: string,
        surname: string,
        maxRow: number,
        minRow: number,
        serviceProposition: ServiceProposition
    ): void {
        const currentAccount = MoveableSubAccountStore.getCurrentAccount();
        const client = new TransferDestinationAccountsClient();
        var subAccountTypes = [currentAccount.SubAccountType]
        DestinationSubAccountDispatcher.dispatch({
            actionType: ActionType.Loading,
        });
        const promise = client.get(
            accountName,
            accountNum,
            forname,
            surname,
            maxRow,
            minRow,
            subAccountTypes,
            currentAccount.WrapProvider,
            serviceProposition
        );
        promise.onSuccess((data) => {
            DestinationSubAccountDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getDestinationAccountFromRequest(hierarchyid: string): void {
        const client = new TransferSourceAccountsClient();
        const promise = client.get(hierarchyid);
        promise.onSuccess((data) => {
            const subAccount = data.SourceAccounts.find((ele) => ele.HierarchyId === hierarchyid);
            const destinationAccount: TransferDestinationAccountModel = {
                ClAccountId: subAccount.ClAccountId,
                HierarchyId: hierarchyid,
                SubAccountType: subAccount.SubAccountType,
                ProductDisplayName: subAccount.ProductDisplayName,
            };
            DestinationSubAccountFromRequestDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: destinationAccount,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getRequest(requestId: number) {
        const client = new AccountTransferClient();
        const promise = client.get(requestId);

        promise.onSuccess((data) => {
            TransferRequestDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static submit(
        transferAccountInstruction: AccountTransferInstruction,
        onSuccess?: () => void,
        onFailure?: (val: IApiError<InterAccountTransferErrors>[]) => void
    ): void {
        const client = new AccountTransferClient();
        DestinationSubAccountDispatcher.dispatch({
            actionType: ActionType.Loading,
        });
        const promise = client.post(transferAccountInstruction);
        promise.onSuccess(() => onSuccess());
        promise.onError((errors) => onFailure(errors));
    }

    public static getBeneficialOwner(sourceAccount: string, destinationAccount: string, callback) {
        const client = new TransferBeneficialOwnerClient();
        const promise = client.get(sourceAccount, destinationAccount);
        promise.onSuccess((d) => callback(d));
        promise.onError((errors) => {});
    }
}
